module.exports = __webpack_public_path__ + "static/framing-90552554c08bd230ac62098dd66151de.jpg";